import React, { Component } from 'react';
import ScreenAlertModal from './ScreenAlertModal.react.js';
import PrinterStatusModal from './PrinterStatusModal.react.js';
let i18n = require("i18next");
let styles = require('../css_modules/helpModal.less');
import classNames from 'classnames';


const images = {
    webchat: require("../images/pos/help/help-webchat.png"),
    webchaten: require("../images/pos/help/help-webchat-en.png"),
    helpcenter: require("../images/pos/help/help-center.png"),
    helpcenteren: require("../images/pos/help/help-center-en.png"),
}

export default class HelpModal extends Component {
    chat() {
        let link = this.props.locale=="zh_CN" ? "http://wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzgwMDA5ODQ3N18yMTgyMDhfODAwMDk4NDc3XzJf;" :
            "javascript:void(0);";

        let imageSrc = images['webchat' + (this.props.locale=="zh_CN" ? "" : "en")];
        return (
            <a id="webchatHelp" href={link} target="_blank" className={classNames(styles.helpBlock, styles.one)}>
                <img src={imageSrc}/>
                <span className={styles.helpText}>
                    <strong>{i18n.t("help.popup.webchat.label")}</strong><br/>
                    {i18n.t("help.popup.webchat.desc")}<br/>
                    {i18n.t("help.popup.webchat.time")}<br/>
                    <i>{i18n.t("help.popup.enquirenow")}</i>
                </span>
            </a>
        );
    }

    helpCenter() {
        let imageSrc = images['helpcenter' + (this.props.locale=="zh_CN" ? "" : "en")];
        return (
            <a href="/help" className={classNames(styles.helpBlock, styles.two)}>
                <img src={imageSrc}/>
                <span className={styles.helpText}>
                    <strong>{i18n.t("help.popup.helpcenter.label")}</strong><br/>
                    {i18n.t("help.popup.helpcenter.desc")}<br/>
                    {i18n.t("help.popup.helpcenter.time")}<br/>
                    <i>{i18n.t("help.popup.enquirenow")}</i>
                </span>
            </a>
        );
    }

    render() {
        const classes = "modal wide-modal " + styles.helpModal;

        return (
            <div className={classes} id="helpModal" tabIndex="-1" role="dialog" aria-labelledby="helpModalLabel" aria-hidden="true">
                <div className={classNames('modal-dialog', styles['modal-dialog'])}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">{i18n.t("pos.header.help")}</h4>
                            <button type="button" className="btn btn-close" data-dismiss="modal" style={{float: "right"}}></button>
                        </div>

                        <div className={classNames('modal-body', styles['modal-body'])}>
                            <p>
                                {i18n.t(this.props.firstLogin ? "help.popup.title.newhand" : "help.popup.title.label")}
                            </p>
                            {this.chat()}
                            {this.helpCenter()}
                            <a href="tel:00862782822869" className={classNames(styles.helpBlock, styles.three)}>
                                <img src={require("../images/pos/help/help-phone.png")}/>
                                <span className="helpText">
                                    <strong>{i18n.t("help.popup.phone.label")}</strong><br/>
                                    {i18n.t("help.popup.phone.desc")}<br/>
                                    {i18n.t("help.popup.phone.number")}<br/>
                                    {i18n.t("help.popup.phone.time")}<br/>
                                    <i>{i18n.t("help.popup.enquirenow")}</i>
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/react/HelpModal.react.js